module.exports = __webpack_public_path__ + "media/img/illustrations/check@1.5x-57e78063afaa926d9fecaa03aaff7811.svg";